export function computeIsBusying ({ addrid, transport, isBusySeason, userJypointBalance }) {
  if (addrid === '1598') return false
  return transport === 'se' &&
    isBusySeason &&
    String(userJypointBalance) !== '999999'
}

export function computeJyoBusyFeeWg ({ parcelsFeeFormulas }) {
  if (parcelsFeeFormulas) return parcelsFeeFormulas.srChgWeight / 1000
  return 0
}

export function computeJyoBusyFeeData ({
  finalSr,
  shippingRatesInfo,
  isBusying,
  jyoBusyFeeWg,
  isLong91,
  showJybCoinFeatures,
  hasJyorder,
  userKnapsackBusyfee128,
  userKnapsackBusyfee158,
}) {
  const result = {
    fee: 0,
    weight: 0,
    useKnsCount: 0,
  }
  const sr = finalSr || shippingRatesInfo
  if (['ENT1688', 'BIZECO', 'BIZECOJJU'].includes(sr.srLabel)) return result

  if (isBusying) {
    let userKnapsackBusyfee = null
    if (hasJyorder >= 20 && userKnapsackBusyfee128?.ksugBalance > 0) {
      userKnapsackBusyfee = userKnapsackBusyfee128
    } else if (userKnapsackBusyfee158?.ksugBalance > 0) {
      userKnapsackBusyfee = userKnapsackBusyfee158
    }
    if (isLong91) {
      result.weight = Math.ceil(jyoBusyFeeWg)
      result.fee = 0
      result.freeFeeByLong91 = result.weight * 10
    } else if (showJybCoinFeatures && userKnapsackBusyfee?.ksugBalance > 0) {
      const weight = Math.ceil(jyoBusyFeeWg)
      result.weight = Math.max(weight - userKnapsackBusyfee.ksugBalance, 0)
      result.useKnsCount = weight - result.weight
      result.fee = result.weight * 10
    } else {
      result.weight = Math.ceil(jyoBusyFeeWg)
      result.fee = result.weight * 10
    }
  }
  return result
}

export function computeLocalFee ({
  addrInfo,
  sedeFee,
  jyoCarrier,
  parcelsFeeFormulas,
  srLabel,
}) {
  if (!addrInfo || sedeFee || srLabel === 'HZKZQ' || !parcelsFeeFormulas || parcelsFeeFormulas.srChgWeight) return 0
  if (jyoCarrier === 'hct') return parcelsFeeFormulas.localFeesHct?.[0] || 0
  if (jyoCarrier === 'tcat') return parcelsFeeFormulas.localFeesTcat?.[0] || 0
  if (jyoCarrier === '711') return parcelsFeeFormulas.localFees711?.[0] || 0
  if (jyoCarrier === 'pch') return parcelsFeeFormulas.localFeesPch?.[0] || 0
  return 0
}
